import React, { Component } from 'react'
import { Divider, Embed } from 'semantic-ui-react'
import { TransitionContainer } from '../utility/GlobalComponents'

import youtubeIds from '../assets/json/youtube.json'


export default class Videos extends Component {

    render () {
        return (
            <TransitionContainer className='mv-videos-container'>
                <section>
                {youtubeIds.map((item,index) => 
                        <section key={index}>
                            <Embed
                            defaultActive
                            source={item?.source}
                            url={item?.url}
                            id={item?.id}
                            />

                            <Divider />
                        </section>
                    )}
                </section>
            </TransitionContainer>
        )
    }
}